export default __webpack_public_path__ + "static/media/no_img__placeholder.444b0438.svg";